export default "__VITE_ASSET__DFnwYKl8__"